import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { CleanDatePipe } from 'src/app/pipes/clean-date.pipe';
import { AccessService } from '../../navigation/service/access.service';
import { ContactMechanismPurposeTypes } from '../../party/model/contact-mechanism-purpose-types.model';
import { ContactMechanismTypes } from '../../party/model/contact-mechanism-types.model';
import { PartyContactMechanisms } from '../../party/model/party-contact-mechanisms.model';
import { PartyRoleTypes } from '../../party/model/party-role-types.model';

import { PCMEditInterface } from '../model/pcm-edit-interfacte';
import { Email } from './email';

@Component({
    selector: 'app-email',
    templateUrl: './email.component.html',
    styleUrls: ['./email.component.scss']
})
export class EmailComponent implements OnInit, AfterViewInit, OnChanges {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    displayedColumns: string[] = EmailColumns.map((col) => col.key);
    columnsSchema: any = EmailColumns;
    dataSource = new MatTableDataSource<Email>();
    contactMechanismTypes: ContactMechanismTypes[] = [];
    contactMechanismPurposeTypes: ContactMechanismPurposeTypes[] = [];

    partyRoleType!: PartyRoleTypes;
    lstEmaildata: Email[] = [];

    email = new UntypedFormControl('', [Validators.required, Validators.email]);

    @Input() type!: 'People' | 'Organization';
    @Input() filterTypes: string[] = [];
    @Input() refresh: boolean = false;
    @Input() readOnly: boolean = false;
    @Input() data: PartyContactMechanisms[] = [];
    @Output() partyContactMechanismsChange: EventEmitter<PCMEditInterface> = new EventEmitter<PCMEditInterface>();

    constructor(
        public dialog: MatDialog,
        //private contactMechanismsService: ContactMechanismsService,
        //private partyRolesService: PartyRolesService,
        private accessService: AccessService
    ) {}

    ngOnInit(): void {
        this.getContactMechanismTypes();
        this.getContactMechanismPurposeTypes();
        this.getPartyRoleType();
    }

    populateEmailData() {
        this.lstEmaildata = [];
        if (this.data) {
            const now = new Date().getTime();

            let filterParyContanctMechanisms: PartyContactMechanisms[] = this.data.filter(
                (x) => x.CONTACT_MECHANISMS?.CONTACT_MECHANISM_TYPES?.TYPE === 'Email'
            );

            filterParyContanctMechanisms.forEach((p) => {
                p.CREATED_DATE = new CleanDatePipe().transform(p.CREATED_DATE!);
            });

            filterParyContanctMechanisms.sort((a, b) => {
                return (b.CREATED_DATE ? b.CREATED_DATE!.getTime() : now) - (a.CREATED_DATE ? a.CREATED_DATE!.getTime() : now);
            });

            let currentPCM: PartyContactMechanisms[] = [];
            let pastPCM: PartyContactMechanisms[] = [];

            this.filterTypes.forEach((type) => {
                let filterPCMbyTypes = filterParyContanctMechanisms.filter(
                    (x) => x.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE === type
                );
                if (filterPCMbyTypes.length == 1) {
                    currentPCM.push(filterPCMbyTypes[0]);
                } else {
                    filterPCMbyTypes.sort((a, b) => {
                        return (b.CREATED_DATE ? b.CREATED_DATE!.getTime() : now) - (a.CREATED_DATE ? a.CREATED_DATE!.getTime() : now);
                    });

                    filterPCMbyTypes.forEach((pcmtype, index) => {
                        if (index == 0) currentPCM.push(pcmtype);
                        else pastPCM.push(pcmtype);
                    });
                }
            });

            currentPCM.forEach((element) => {
                this.lstEmaildata.push({ isEdit: false, partyContactMechanisms: element });
            });
            pastPCM.forEach((element) => {
                this.lstEmaildata.push({ isEdit: false, partyContactMechanisms: element });
            });
        }

        this.dataSource.data = this.lstEmaildata;
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }
    ngOnChanges(changes: SimpleChanges): void {
        this.populateEmailData();
    }

    addRow() {
        this.dataSource.data.findIndex((x) => x.isEdit == true) == -1
            ? (this.dataSource.data = [{ isEdit: true, partyContactMechanisms: this.buildContactMechanisms() }, ...this.dataSource.data])
            : null;

        this.ngAfterViewInit();
    }

    editRow(row: Email) {
        this.dataSource.data.findIndex((x) => x.isEdit == true) === -1 ? (row.isEdit = true) : null;
    }

    updateRow(row: Email) {
        row.isEdit = false;
        this.emitdataSource();
    }

    removeRow(id: number) {
        let removedItem = this.dataSource.data.find((u: Email) => u.partyContactMechanisms.ID == id);
        this.dataSource.data = this.dataSource.data.filter((u: Email) => u.partyContactMechanisms.ID !== id);

        //exiting record deleted then notify otherwise send null
        if (removedItem?.partyContactMechanisms.ID || 0 >= 1) this.emitdataSource(removedItem?.partyContactMechanisms);
        else this.emitdataSource(undefined);
    }

    cancelRow(row: Email) {
        row.isEdit = false;

        //revert back to original state
        //get the original data from PhoneData and update the row else remove the data.
        let email = this.lstEmaildata.find((x) => x.partyContactMechanisms.ID === row.partyContactMechanisms.ID);
        if (email != undefined && email.partyContactMechanisms.ID! > 0) {
            row.partyContactMechanisms = email.partyContactMechanisms;
        } else this.dataSource.data = this.dataSource.data.filter((u: Email) => u.partyContactMechanisms.ID !== row.partyContactMechanisms.ID);
    }

    disableSubmit(row: Email) {
        if (
            row.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES?.[0]?.CONTACT_MECHANISM_PURPOSE_TYPES?.TYPE &&
            (row.partyContactMechanisms.CONTACT_MECHANISMS!.EMAILS?.[0]?.EMAIL_ADDRESS?.length || 0) > 0 &&
            this.email.valid
        ) {
            return false;
        } else return true;
    }

    isRowEditable(row: Email) {
        const now = new Date().getTime();
        if (row.partyContactMechanisms.ID! > 0) {
            let type: string = row.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE || '';
            let filterTypes = this.lstEmaildata.filter(
                (x) => x.partyContactMechanisms.PARTY_CONTACT_MECHANISM_PURPOSES![0].CONTACT_MECHANISM_PURPOSE_TYPES!.TYPE === type
            );
            if (filterTypes.length == 1) return true;
            else {
                filterTypes.sort((a, b) => {
                    return (
                        (b.partyContactMechanisms.CREATED_DATE ? b.partyContactMechanisms.CREATED_DATE!.getTime() : now) -
                        (a.partyContactMechanisms.CREATED_DATE ? a.partyContactMechanisms.CREATED_DATE!.getTime() : now)
                    );
                });
                return filterTypes[0].partyContactMechanisms.ID === row.partyContactMechanisms.ID;
            }
        } else {
            return true;
        }
    }

    buildContactMechanisms(): PartyContactMechanisms {
        const arrPCMId = this.toNumberArray(this.dataSource.data);
        let min = arrPCMId.length > 0 ? arrPCMId.reduce((a, b) => Math.min(a, b)) : 0;
        min = min > 0 ? -1 : min - 1;

        let tempPCM = new PartyContactMechanisms();
        tempPCM = {
            ID: min,
            PARTY_ROLE_TYPES: this.partyRoleType,
            PARTY_CONTACT_MECHANISM_PURPOSES: [{ CONTACT_MECHANISM_PURPOSE_TYPES: undefined }],
            CONTACT_MECHANISMS: {
                CONTACT_MECHANISM_TYPES: this.getContactMechanismType('Email'),
                POSTAL_ADDRESSES: [{}],
                EMAILS: [
                    {
                        EMAIL_ADDRESS: ''
                    }
                ],
                TELEPHONE_NUMBERS: [
                    {
                        PHONE_NUMBER: '',
                        EXT: ''
                    }
                ]
            }
        };

        return tempPCM;
    }

    compareFn(o1: any, o2: any) {
        if (!o1 || !o2) {
            return false;
        }

        return o1.ID === o2.ID;
    }

    emitdataSource(removedItem?: PartyContactMechanisms) {
        let eventChangedPCM: PartyContactMechanisms[] = this.dataSource.data.map((x) => x.partyContactMechanisms);
        this.partyContactMechanismsChange.emit({ editpartyContactMechanisms: eventChangedPCM, deletePartyContactMechanisms: removedItem });
    }

    //Change this API service to read from ngrx store
    getContactMechanismTypes() {
        this.accessService.getContactMechanism().subscribe((res: ContactMechanismTypes[]) => {
            this.contactMechanismTypes = res;
        });
        /*this.contactMechanismsService.indexContactMechanismTypes().subscribe((res: any) => {
		this.contactMechanismTypes = res.contactMechanismTypes;
	});*/
    }
    getContactMechanismType(type: string): ContactMechanismTypes | undefined {
        let output: ContactMechanismTypes | undefined = new ContactMechanismTypes();
        output = this.contactMechanismTypes.find((contactMechanismType) => {
            return contactMechanismType.TYPE === type;
        });
        return output;
    }

    getContactMechanismPurposeTypes() {
        this.accessService.getContactMechanismPurpose().subscribe((res: ContactMechanismPurposeTypes[]) => {
            let a: ContactMechanismPurposeTypes[] = res;
            this.filterTypes.forEach((type) => this.contactMechanismPurposeTypes.push(a.find((x) => x.TYPE == type)!));
        });

        /*this.contactMechanismsService.indexContactMechanismPurposeTypes().subscribe((res: any) => {
		let a: ContactMechanismPurposeTypes[] = res.contactMechanismPurposeTypes;
		this.filterTypes.forEach((type) => this.contactMechanismPurposeTypes.push(a.find((x) => x.TYPE == type)!));
	});*/
    }

    getPartyRoleType() {
        const type = this.type === 'People' || '' ? 'Person' : this.type;
        this.accessService.getPartyRoleTypes().subscribe((res: PartyRoleTypes[]) => {
            let prType = res.find((x: PartyRoleTypes) => x.TYPE === type);
            if (prType != undefined && prType.ID > 0) {
                this.partyRoleType = prType;
            }
        });

        /*this.partyRolesService.indexPartyRoleTypesByCategory(this.type).subscribe((res) => {
		const type = this.type === 'People' || '' ? 'Person' : this.type;

		this.partyRoleType = res.partyRoleTypes?.find((prt: PartyRoleTypes) => {
			return prt.TYPE === type;
		});
	});*/
    }

    toNumberArray(array: Email[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.partyContactMechanisms.ID ? returnArray.push(obj.partyContactMechanisms.ID) : null;
        });

        return returnArray;
    }
}

export const EmailColumns = [
    {
        key: 'activeDate',
        type: 'date',
        label: 'Active Date'
    },
    {
        key: 'emailType',
        type: 'text',
        label: 'Email Type'
    },
    {
        key: 'email',
        type: 'text',
        label: 'Email',
        required: true
    },
    {
        key: 'isEdit',
        type: 'isEdit',
        label: ''
    }
];
